import { ButtonProps } from '@mui/material';
import { StyledFilterButton } from './FilterButton.sx';

export interface FilterButtonProps extends Omit<ButtonProps, 'color'> {
  isActive?: boolean;
  color?: 'primary' | 'secondary' | 'tertiary' | 'error' | 'info' | 'success' | 'warning';
}

export const FilterButton = ({ isActive = false, ...props }: FilterButtonProps) => {
  return <StyledFilterButton isActive={isActive} {...props} />;
};
